export const breakpoints = {
    mediumMin: 'min-width: 600px',
};
